import { usePaymentHistoryQuery } from '@entities/payment'
import { MenuRow } from '@shared/ui/menu-row'
import { HiMiniCreditCard } from 'react-icons/hi2'

function formatDate(dateStr: string): string {
  const d = new Date(dateStr)
  return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`
}

export function PaymentHistorySection() {
  const { data: paymentHistory } = usePaymentHistoryQuery()

  if (!paymentHistory || paymentHistory.length === 0) {
    return null
  }

  return (
    <MenuRow.Accordion icon={HiMiniCreditCard} label="결제 내역" count={paymentHistory.length}>
      <div className="flex flex-col gap-2 pb-3 divide-y divide-border pt-1">
        {paymentHistory.map((item) => (
          <div key={item.orderId} className="flex w-full items-center justify-between px-4 py-3">
            <div className="flex flex-col gap-0.5">
              <span className="typo-label font-medium text-foreground">{item.orderName}</span>
              <span className="typo-footnote text-muted-foreground">
                {formatDate(item.approvedAt || item.createdAt)}
              </span>
            </div>
            <span className="typo-body font-bold text-foreground">
              {item.amount.toLocaleString()}원
            </span>
          </div>
        ))}
      </div>
    </MenuRow.Accordion>
  )
}
